import { render } from "./LabApprove2Appv.vue?vue&type=template&id=15a14b4e"
import script from "./LabApprove2Appv.vue?vue&type=script&lang=js"
export * from "./LabApprove2Appv.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\mlab\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__